module.exports = __webpack_public_path__ + "static/media/video2.6b424ee8.mp4";